module.exports = __webpack_public_path__ + "img/order.cb2bcb25.png";